import { Trans, useTranslation } from 'react-i18next';
import { AppIntroFlow } from '@components/AppIntroFlow/index';
import { PAGINATION_SIZE, Pagination, Select } from '@reverse-hr/design-system';
import { CustomerApplicationsTable } from '@components/CustomerApplications/_partials/CustomerApplicationsTable';
import { useTable } from '@components/CustomerApplications/use-table';
import { useApplications } from '@components/CustomerApplications/use-applications';
import classNames from 'classnames';
import { CUSTOMER_APPLICATIONS_STATE_CATEGORIES } from '@app/constants/applications';

export const CustomerApplications = ({
  stateCategory,
  jobId,
  isStateFilterAvailable,
}) => {
  const { t } = useTranslation();

  const {
    applications,
    pagination,
    state,
    stateSelectOptions,
    sortBy,
    sortDirection,
    isLoading,
    hasError,
    onPageChange,
    onColumnHeaderClick,
    onStateChange,
  } = useApplications({ stateCategory, jobId });

  const { tableColumns, tableRows } = useTable({
    stateCategory,
    applications,
  });

  const tableClassNames = classNames('c-customer-applications__table', {
    'c-customer-applications__table--active':
      stateCategory === CUSTOMER_APPLICATIONS_STATE_CATEGORIES.ACTIVE,
    'c-customer-applications__table--stopped':
      stateCategory === CUSTOMER_APPLICATIONS_STATE_CATEGORIES.STOPPED,
  });

  const isPaginationVisible = pagination.total_pages > 1 && !isLoading;

  const getPageAriaLabel = page =>
    t('homepage.candidates.pagination.pageAriaLabel', { page });

  return (
    <div className="c-customer-applications">
      <AppIntroFlow
        className="c-app-intro-flow--full c-app-intro-flow--text-reverse"
        title={t('homepage.candidates.title', { context: stateCategory })}
        body={
          <Trans
            i18nKey="homepage.candidates.intro"
            components={{ strong: <strong />, br: <br /> }}
            context={stateCategory}
          />
        }
      />

      {isStateFilterAvailable && (
        <Select
          onChange={onStateChange}
          options={stateSelectOptions}
          isSmall
          value={state ?? ''}
        />
      )}

      <CustomerApplicationsTable
        className={tableClassNames}
        columns={tableColumns}
        emptyContent={t('homepage.candidates.table.noApplications', {
          context: hasError ? 'error' : null,
        })}
        isLoading={isLoading}
        onColumnHeaderClick={onColumnHeaderClick}
        rows={tableRows}
        sortBy={sortBy}
        sortDirection={sortDirection}
      />

      {isPaginationVisible && (
        <div className="c-customer-applications__pagination">
          <Pagination
            currentPage={pagination.current_page}
            getPageAriaLabel={getPageAriaLabel}
            navigationAriaLabel={t(
              'homepage.candidates.pagination.navigationAriaLabel',
            )}
            nextPageAriaLabel={t(
              'homepage.candidates.pagination.nextPageAriaLabel',
            )}
            onPageChange={onPageChange}
            previousPageAriaLabel={t(
              'homepage.candidates.pagination.previousPageAriaLabel',
            )}
            size={PAGINATION_SIZE.SMALL}
            totalPages={pagination.total_pages}
          />
        </div>
      )}
    </div>
  );
};
